import { render } from "./parentIndex.vue?vue&type=template&id=5c60f558&scoped=true"
import script from "./parentIndex.vue?vue&type=script&lang=js"
export * from "./parentIndex.vue?vue&type=script&lang=js"

import "./parentIndex.vue?vue&type=style&index=0&id=5c60f558&lang=less&scoped=true"

import exportComponent from "/Users/yiduolanghua/Desktop/edu/visitor-h5-jy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c60f558"]])

export default __exports__